﻿import {hide, show} from "@/Utils"

export function initFileUpload() {

    const fileUploadDiv = document.querySelector('.file-upload') as HTMLDivElement;

    if (!fileUploadDiv) return;

    const allowMultipleFiles = fileUploadDiv.getAttribute('data-allow-multiple-files') === 'True';
    const uploadBtnDiv = fileUploadDiv?.querySelector('.upload-button-wrapper') as HTMLDivElement;
    const titleDiv = fileUploadDiv?.querySelector('.title') as HTMLDivElement;
    const titleOrArea = titleDiv?.querySelector('.title-or-area') as HTMLDivElement;
    const filenamesContainerDiv = fileUploadDiv?.querySelector('.filenames__container') as HTMLDivElement;
    const descriptionDiv = fileUploadDiv?.querySelector('.description') as HTMLDivElement;

    const fileUploadMessageDiv = fileUploadDiv?.querySelector('.message') as HTMLDivElement;
    const successSpan = fileUploadMessageDiv?.querySelector('.success') as HTMLSpanElement;
    const errorSpan = fileUploadMessageDiv?.querySelector('.error') as HTMLSpanElement;
    const errorSizeSpan = fileUploadMessageDiv?.querySelector('.error_size') as HTMLSpanElement;
    const errorExtSpan = fileUploadMessageDiv?.querySelector('.error_extension') as HTMLSpanElement;
    const errorRetrySpan = fileUploadMessageDiv?.querySelector('.error_retry') as HTMLSpanElement;

    const maxFileSize = 10 * 1024 * 1024;
    const fileInput = fileUploadDiv.querySelector("input[type=file]") as HTMLInputElement;
    const allowedTypes = fileInput.getAttribute('data-allowed-types');
    const dataTransfer = new DataTransfer();

    resetDivVisibility(true);

    // Prevent defaults on Drag and Drop events
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        fileUploadDiv.addEventListener(eventName, preventDefaults, false);
    });

    // Handle dropped files
    fileUploadDiv.addEventListener('drop', (e: DragEvent) => {
        const dt = e.dataTransfer;
        if (dt?.files) {
            handleFiles(dt.files);
        }
    });

    // Handle click upload
    const uploadButton = fileUploadDiv.querySelector('.button--file-upload') as HTMLButtonElement;
    uploadButton.addDataBoundEventListener('click', () => {
        fileInput.click();
    });

    fileInput.addDataBoundEventListener('change', (e) => {
        const target = e.target as HTMLInputElement;
        if (target.files && target.files.length > 0) {
            handleFiles(target.files);
        } 
    });
    
    function handleFiles(files: FileList) {
        if (files.length > 0 && (allowMultipleFiles || dataTransfer.files.length === 0)) {

            resetDivVisibility();

            const file = files[0];
            // Check file type
            if (!file.type.match(allowedTypes)) {

                show(fileUploadMessageDiv);
                show(errorSpan);
                show(errorExtSpan);
                show(errorRetrySpan);
                fileInput.files = dataTransfer.files;
                return;
            }
            
            const totalSize = file.size + Array.from(dataTransfer.files).reduce((acc, existingFile) => acc + existingFile.size, 0);
            if (totalSize > maxFileSize) {

                show(fileUploadMessageDiv);
                show(errorSpan);
                show(errorSizeSpan);
                show(errorRetrySpan);
                fileInput.files = dataTransfer.files;
                return;
            }

            dataTransfer.items.add(file);
            fileInput.files = dataTransfer.files;
            const fileNameContainerDiv = document.createElement("div");
            fileNameContainerDiv.classList.add("filename__container");
            const removeFileSpan = document.createElement("span");
            removeFileSpan.classList.add("remove-file", "icon-file-remove");
            removeFileSpan.addEventListener('click', () => {
                const indexToRemove = Array.from(dataTransfer.files).findIndex(
                    (existingFile) => existingFile.name === file.name
                );
                if (indexToRemove !== -1) {
                    dataTransfer.items.remove(indexToRemove);
                    fileInput.files = dataTransfer.files;
                }
                fileNameContainerDiv.parentNode.removeChild(fileNameContainerDiv);
                resetDivVisibility(true);
                // Show the upload button again
                show(uploadBtnDiv);
                show(titleOrArea);
            });
            const fileNameSpan = document.createElement("span");
            fileNameSpan.classList.add("filename");
            fileNameSpan.textContent = file.name;
            fileNameContainerDiv.appendChild(removeFileSpan);
            fileNameContainerDiv.appendChild(fileNameSpan);
            filenamesContainerDiv.appendChild(fileNameContainerDiv);

            show(filenamesContainerDiv);
            show(fileUploadMessageDiv);
            show(successSpan);

            if(!allowMultipleFiles){
                hide(uploadBtnDiv);
                hide(titleOrArea);
            }
        }
    }
    
    function resetDivVisibility(isInitialLoad: boolean = false) {
        hide(fileUploadMessageDiv);
        hide(successSpan);
        hide(errorSpan);
        hide(errorSizeSpan);
        hide(errorExtSpan);
        hide(errorRetrySpan);

        if (isInitialLoad) {
            show(descriptionDiv);
        } else {
            hide(descriptionDiv);
        }
    }

    function preventDefaults(e: Event) {
        e.preventDefault();
        e.stopPropagation();
    }
}